import React, { useMemo, useState } from "react";
import styles from "./Page.module.css";
import Footer from "../../views/components/Footer/Footer";

import { ReactComponent as SearchIcon } from "./../../assets/svg/search-normal.svg";
import { ReactComponent as NotificationIcon } from "./../../assets/svg/notification.svg";

import "./Page.css";
import Campaign from "../Campaign/Campaign";
import { ReactComponent as GMallIcon } from "../../assets/svg/gmall-logo.svg";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLangNavigate } from "../../hooks/useLangNavigate";
import { LangLink } from "../../views/components/LangLink/LangLink";
import { useLocation, useParams } from "react-router-dom";
import { NotificationButton } from "./NotificationButton";
import SwitchLanguage from "../../views/components/switchlanguage/switchLanguage";

const Page = (props) => {
  const { i18n } = useTranslation();
  const notifications = useSelector((state) => state.Notification);
  const navigate = useLangNavigate();
  const { lang } = useParams();
  const location = useLocation();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const root_classes = [];
  if (props.className) {
    root_classes.push("helbest-page-container", props.className);
  } else {
    root_classes.push("helbest-page-container");
  }
  if (props.mobileContainer) {
    root_classes.push("mobile-container");
  }

  const changeLanguage = (newLang) => {
    const newPath = location.pathname.replace(
      `/${i18n.language}`,
      `/${newLang}`
    );
    i18n.changeLanguage(newLang);
    navigate({
      pathname: newPath,
      search: location.search,
      replace: true,
    });
  };

  const langs = { ar: "English", en: "العربيه" };

  return (
    <div className={root_classes.join(" ")}>
      {isPopoverOpen && <div className={styles.backdrop} />}

      {props.hasHeader ? <Campaign /> : null}

      {props.customHeader ? props.customHeader : null}

      {props.noHeader || props.customHeader ? null : (
        <header
          className={`helbest-page-header ${props.headerFix ? "fix-top" : ""}`}
        >
          <div className={styles.HeaderButtons}>
            <div>
              <LangLink to="/search" className={styles.IconContainer}>
                <SearchIcon className={styles.SearchIcon} />
              </LangLink>
            </div>
            <NotificationButton onOpenChange={setIsPopoverOpen} />

            {/* <LangLink className={styles.IconContainer} to={"/notifications"}>
                <NotificationIcon className={styles.CarIcon} />
                {unseen_notif && (
                  <span className={`${styles.NotificationCircle} pulse`} />
                )}
              </LangLink> */}
            <div>
              <SwitchLanguage />
            </div>
          </div>

          <div className="helbest-page-header-mid">
            {props.title && (
              <div className="helbest-page-header-title">{props.title}</div>
            )}
            {props.category && <div className="category_shower">category</div>}
          </div>

          <div className={styles.HeaderLeft}>
            {props.drawer}
            <GMallIcon
              className={styles.GMallIcon}
              onClick={() => navigate("/")}
            />
          </div>
        </header>
      )}

      {props.extra_header || null}

      <section
        style={{
          backgroundColor: props.customBg || "#f8f9fb",
        }}
        className={`${
          props.mobileMode
            ? "helbest-mobile-mode"
            : "helbest-desktop-page-body-wraper"
        } ${props.bodyWrapperClassName || ""}`}
      >
        <div
          className={`helbest-page-body sides-padding ${
            props.mobileContainer ? "mobile-container" : ""
          } ${props.customPageClassName || ""}`}
          style={{ paddingBottom: "65px" }}
        >
          {props.category && <div className="category"></div>}
          {props.children}
        </div>
      </section>
      {props.showFooter && (
        <>
          {props.footer && !props.noFooter && (
            <>
              <div className="fix-footer">{props.footer}</div>
            </>
          )}
          {!props.footer && !props.noFooter && (
            <>
              {/* <div className="helbest-fix-footer"></div>   */}
              <footer className="helbest-page-footer">
                <Footer />
              </footer>
              {/* <div className={styles.RoundPeaseFooterContainer}>
                <div className={styles.LeftRound}
                  style={{
                    clipPath: `polygon(${circleClip.join(',')},0 100%,100% 100%,100% 0)`,
                    color: 'red'
                  }}
                />
                <div className={styles.RightRound}
                  style={{
                    clipPath: `polygon(${circleClip.join(',')}, 0 100%, 100% 100%, 100% 0)`,
                    color: 'red'
                  }}
                />
              </div> */}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Page;
